import { useMutation } from '@tanstack/react-query'

import { authApi } from '@/api/authApi'
import { queryClient } from '@/lib/query/queryClient'
import { useAuthStore } from '@/stores/authStore'

export function useSwitchLocation() {
  return useMutation({
    mutationFn: (location: string) => authApi.switchLocation(location),
    onSuccess: async (session) => {
      useAuthStore.getState().setSession(session)
      // Everything cached belonged to the old location — its today, its call
      // list, its calendar, its customers. Reset rather than clear, so the
      // screen on display refetches instead of holding an orphaned observer.
      await queryClient.resetQueries()
    },
  })
}
